// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_wfJ","fullView":"styles_fullView__1YBbc"};